import { Tab } from 'tab-election';
import { agreeableWorkerLeader } from './workerLeader';
export async function agreeableWorker(config, options) {
    if (!config.domain) {
        throw new Error('Malformed config, no domain property present');
    }
    if (!options.uid || !options.appVersion) {
        const params = new URLSearchParams(globalThis.location.search);
        options.uid = params.get('uid');
        options.appVersion = params.get('appVersion');
        if (!options.uid || !options.appVersion) {
            throw new Error('Missing `uid` || `appVersion`');
        }
    }
    const uid = options.uid;
    const tab = new Tab(`${config.name}/${options.appVersion}/${uid}`);
    let leader;
    globalThis.tab = tab;
    await tab.waitForLeadership(async () => {
        leader = await agreeableWorkerLeader(config, options, tab);
        globalThis.leader = leader;
        await leader.open();
        return leader;
    });
    if (leader) {
        leader.close();
    }
}
